import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=27126080&scoped=true"
import script from "./myAccount.vue?vue&type=script&lang=js"
export * from "./myAccount.vue?vue&type=script&lang=js"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=27126080&prod&lang=less&scoped=true"
import style1 from "./myAccount.vue?vue&type=style&index=1&id=27126080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27126080",
  null
  
)

export default component.exports